/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import InsticatorLogo from 'components/shared/logo/insticator/insticator_container';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/footer/footer_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:true});



/* ========== ~~~~~~~~~~ FOOTER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Footer extends Component {
	constructor(props) {
		super(props);
        // Styles of this component depend on whether or not the rewards are enabled/permitted for the embed.
        // Sets initial values based off the rewards settings and status.
		sheet.update(props.rewardsEnabled && props.rewardsPermitted)
	}
    componentWillReceiveProps(nextProps) {
		this.adjustStylesForRewards(nextProps)
	}
	adjustStylesForRewards(nextProps) {
        if (this.props.rewardsEnabled && this.props.rewardsPermitted !== nextProps.rewardsPermitted) {
            sheet.update(nextProps.rewardsPermitted)
        }
	}
	render() {
		let elSettings = this.props.currentContentSettings.elements.footer;
		if (!elSettings) { return false; }
		return (
	        <div className={`${sheet.classes.footer} footer large-${this.props.enlargedFont}`}>
	        	<div className={`inner`}>
		        	{elSettings.companyLogo.visible === true ? <InsticatorLogo contentId={this.props.contentId} poweredBy={true} /> : null}

			    </div>
                {this.props.children}
	        </div>
    	);
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Footer;
